import React from "react"
import FormAuth from "@Components/Authentication"

const LoginScreen = () => {
  return <FormAuth />
}

export default LoginScreen
